<template>
  <div>
    <template v-if="parseFloat(item.consumo_medio_mensal) === 0">
      <v-tooltip bottom open-delay="500">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" small class="cursor-help">mdi-cancel</v-icon>
        </template>
        <span>Cobertura de estoque futura indeterminada, pois o produto não possui projeção de vendas.</span>
      </v-tooltip>
    </template>

    <template v-else>
      <slot name="dias" :valor="coberturaEmDias">
        {{ `${Helpers.formatarValorComCasas(coberturaEmDias, 1)} dias` }}
      </slot>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'CalculaCoberturaEstoqueFutura',
  props: {
    item: {
      type: Object,
      required: true
    },
    se_sugestao_zero_exibe_cobertura_atual: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      embalagemMasterAtivada: "EmbalagemTelaDeCompras/getEmbalagemMaster"
    }),
    itemFormatado() {
      const {
        estoque,
        consumo_medio_mensal,
        sugestao,
        estoque_transito,
        tempo_medio_ressuprimento,
        multiplo_compra,
        estoque_futuro_tempo_ressuprimento
      } = this.item

      const valoresFormatados = {
        estoque: parseFloat(estoque) || 0,
        consumoMensal: parseFloat(consumo_medio_mensal) || 0,
        qtdePedido: parseFloat(sugestao) || 0,
        estoqueTransito: parseFloat(estoque_transito) || 0,
        tempoRessuprimento: parseFloat(tempo_medio_ressuprimento) || 0,
        estoqueFuturoTempoRessuprimento	: parseFloat(estoque_futuro_tempo_ressuprimento	) || 0,
      }

      if(!this.embalagemMasterAtivada) {
        return valoresFormatados
      }

      if(this.item.tipo_fator_conversao === 'D') {
        valoresFormatados.estoque = (valoresFormatados.estoque * multiplo_compra)
        valoresFormatados.qtdePedido = (valoresFormatados.qtdePedido * multiplo_compra)
        valoresFormatados.estoqueTransito = (valoresFormatados.estoqueTransito * multiplo_compra)
        valoresFormatados.estoqueFuturoTempoRessuprimento = (valoresFormatados.estoqueFuturoTempoRessuprimento * multiplo_compra)
      } else {
        valoresFormatados.estoque = (valoresFormatados.estoque / multiplo_compra)
        valoresFormatados.qtdePedido = (valoresFormatados.qtdePedido / multiplo_compra)
        valoresFormatados.estoqueTransito = (valoresFormatados.estoqueTransito / multiplo_compra)
        valoresFormatados.estoqueFuturoTempoRessuprimento = (valoresFormatados.estoqueFuturoTempoRessuprimento / multiplo_compra)
      }

      return valoresFormatados
    },
    coberturaEmDias () {
      const {consumoMensal} = this.itemFormatado

      if (!consumoMensal) {
        return 0
      }

      const {estoque, qtdePedido, estoqueFuturoTempoRessuprimento} = this.itemFormatado

      const consumoDiario = (consumoMensal / 30.0)

      if (parseFloat(qtdePedido) <= 0 && this.se_sugestao_zero_exibe_cobertura_atual) {
        return estoque / consumoDiario;
      }

      const estoqueFuturoTempoRessuprimentoMaisPedido = estoqueFuturoTempoRessuprimento + qtdePedido;

      if (estoqueFuturoTempoRessuprimentoMaisPedido === 0) {
        return 0;
      }

      return estoqueFuturoTempoRessuprimentoMaisPedido / consumoDiario;
    }
  }
}
</script>

<style scoped>

</style>
